import { useEffect } from "react";
import { Facebook } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const FACEBOOK_URL = "https://www.facebook.com/share/1E4oGVKLvK/?mibextid=wwXIfr";

const FacebookRedirect = () => {
  useEffect(() => {
    supabase.from("qr_scans").insert({
      platform: "facebook",
      user_agent: navigator.userAgent,
      referrer: document.referrer || null,
    }).then(() => {}, () => {});

    const t = setTimeout(() => {
      window.location.replace(FACEBOOK_URL);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-muted/40 px-6">
      <noscript>
        <meta httpEquiv="refresh" content={`0; url=${FACEBOOK_URL}`} />
      </noscript>
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-[#1877F2] flex items-center justify-center shadow-elegant animate-pulse">
          <Facebook className="w-10 h-10 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-primary mb-2">Redirecting to Facebook…</h1>
        <p className="text-muted-foreground mb-6">
          Taking you to <span className="font-medium">Arabian Al Waha Est</span>
        </p>
        <a
          href={FACEBOOK_URL}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#1877F2] text-white font-medium hover:opacity-90 transition-opacity"
        >
          <Facebook className="w-4 h-4" />
          Open Facebook
        </a>
      </div>
    </main>
  );
};

export default FacebookRedirect;